import React from "react";
import { Link } from "react-router-dom";

// Defining a functional component named ExercisesCard, which takes exercises as props
function ExercisesCard({ exercises }) {
  // Rendering a Link component to navigate to a specific exercise page when clicked
  return (
    <Link
      to={`/exercise/${exercises?.id}`} // Linking to the exercise details page using exercise id
      className="cursor-pointer relative h-[430px] bg-white rounded-md overflow-hidden hover:scale-103 transition-all duration-200 hover:shadow-2xl" // Styling for the card and hover effects
    >
      {/* Rendering exercise GIF */}
      <img
        src={exercises?.gifUrl} // Setting the source of the image to the GIF URL of the exercise
        alt={exercises?.name} // Setting the alt text of the image to the exercise name
        loading="lazy" // Lazy loading the image for better performance
        className="h-auto relative" // Styling for the image
      />
      {/* Displaying buttons for body part and target muscle group */}
      <div className="absolute left-2 bottom-10 flex gap-2">
        {/* Button for displaying the body part of the exercise */}
        <button className="text-sm capitalize py-1 px-2 font-medium rounded-full text-white bg-red-500">
          {exercises?.bodyPart} {/* Displaying the body part of the exercise */}
        </button>
        {/* Button for displaying the target muscle group of the exercise */}
        <button className="text-sm capitalize py-1 px-2 font-medium rounded-full text-white bg-black">
          {exercises?.target} {/* Displaying the target muscle group of the exercise */}
        </button>
      </div>
      {/* Displaying the name of the exercise */}
      <div className="absolute bottom-1 left-2 text-sm font-bold capitalize">
        {exercises?.name} {/* Displaying the name of the exercise */}
      </div>
    </Link>
  );
}

// Exporting the ExercisesCard component as the default export
export default ExercisesCard;
